export default "__VITE_ASSET__DQRphhMC__"